export default {
  address: {},
  checkedAddress: {},
  //   latlng: {},
  finalAddress: {},
  municipality: "",
};
